var _path, _path2, _circle, _circle2, _circle3, _circle4, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneralReviews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1818 28.6621L53.9091 43.3894L34.2533 50.4093C32.953 50.8737 31.6975 49.6182 32.1619 48.3179L39.1818 28.6621Z",
    fill: "#A6B6EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 67C54.9117 67 67 54.9117 67 40C67 25.0883 54.9117 13 40 13C25.0883 13 13 25.0883 13 40C13 45.4404 14.6091 50.5049 17.3772 54.7438L14.1619 63.7467C13.6975 65.047 14.953 66.3025 16.2533 65.8381L25.2562 62.6228C29.4951 65.3909 34.5596 67 40 67Z",
    fill: "#C1CCF4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 3,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 40,
    r: 3,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 40,
    r: 3,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 10,
    fill: "#17C5D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.25 58C63.25 58.6904 62.6904 59.25 62 59.25C61.3096 59.25 60.75 58.6904 60.75 58C60.75 57.3096 61.3096 56.75 62 56.75C62.6904 56.75 63.25 57.3096 63.25 58Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62 61.5V66",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralReviews);
export default __webpack_public_path__ + "static/media/general_reviews.f9a4a93adff2221ede17f0051aafbdfd.svg";
export { ForwardRef as ReactComponent };